/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SourceRouteImport } from './routes/source'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as RefineRouteImport } from './routes/refine'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GallerySessionIdRouteImport } from './routes/gallery_.$sessionId'

const SourceRoute = SourceRouteImport.update({
  id: '/source',
  path: '/source',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const RefineRoute = RefineRouteImport.update({
  id: '/refine',
  path: '/refine',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GallerySessionIdRoute = GallerySessionIdRouteImport.update({
  id: '/gallery_/$sessionId',
  path: '/gallery/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/gallery': typeof GalleryRoute
  '/organization': typeof OrganizationRoute
  '/pricing': typeof PricingRoute
  '/refine': typeof RefineRoute
  '/results': typeof ResultsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/source': typeof SourceRoute
  '/gallery/$sessionId': typeof GallerySessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/gallery': typeof GalleryRoute
  '/organization': typeof OrganizationRoute
  '/pricing': typeof PricingRoute
  '/refine': typeof RefineRoute
  '/results': typeof ResultsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/source': typeof SourceRoute
  '/gallery/$sessionId': typeof GallerySessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/gallery': typeof GalleryRoute
  '/organization': typeof OrganizationRoute
  '/pricing': typeof PricingRoute
  '/refine': typeof RefineRoute
  '/results': typeof ResultsRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/source': typeof SourceRoute
  '/gallery_/$sessionId': typeof GallerySessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/gallery'
    | '/organization'
    | '/pricing'
    | '/refine'
    | '/results'
    | '/sign-in'
    | '/sign-up'
    | '/source'
    | '/gallery/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/gallery'
    | '/organization'
    | '/pricing'
    | '/refine'
    | '/results'
    | '/sign-in'
    | '/sign-up'
    | '/source'
    | '/gallery/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/gallery'
    | '/organization'
    | '/pricing'
    | '/refine'
    | '/results'
    | '/sign-in'
    | '/sign-up'
    | '/source'
    | '/gallery_/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  GalleryRoute: typeof GalleryRoute
  OrganizationRoute: typeof OrganizationRoute
  PricingRoute: typeof PricingRoute
  RefineRoute: typeof RefineRoute
  ResultsRoute: typeof ResultsRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  SourceRoute: typeof SourceRoute
  GallerySessionIdRoute: typeof GallerySessionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/source': {
      id: '/source'
      path: '/source'
      fullPath: '/source'
      preLoaderRoute: typeof SourceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refine': {
      id: '/refine'
      path: '/refine'
      fullPath: '/refine'
      preLoaderRoute: typeof RefineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery_/$sessionId': {
      id: '/gallery_/$sessionId'
      path: '/gallery/$sessionId'
      fullPath: '/gallery/$sessionId'
      preLoaderRoute: typeof GallerySessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  GalleryRoute: GalleryRoute,
  OrganizationRoute: OrganizationRoute,
  PricingRoute: PricingRoute,
  RefineRoute: RefineRoute,
  ResultsRoute: ResultsRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  SourceRoute: SourceRoute,
  GallerySessionIdRoute: GallerySessionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
